module.exports = __webpack_public_path__ + "img/UMA.00ab5c7a.png";